module.exports = __webpack_public_path__ + "static/media/Technologyicon03.73337132.png";